import React, { Fragment, useState } from "react";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, FormGroup, Badge } from "reactstrap";
import ApplicantData from "../applicant/Data";

const StageView = ({ stage, applicant }) => {
  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  const drawDocuments = () => {
    if (Array.isArray(stage.requested_documents) && stage.requested_documents.length > 0) {
      return (
        <Fragment>
          <hr />
          <h5 className="font-weight-bold text-muted">Documentos Subidos</h5>
          {stage.requested_documents.map((doc, index) => (
            <Row key={index} className="mb-3 align-middle">
              <Col xs="10" lg="8" md="8">
                <div className="media">
                  <i className={`far fa-file fa-2x mr-3 mt-1 ${doc.uploaded ? "text-success" : "text-danger"}`} />
                  <div className="media-body">
                    <h4 className={`mt-1 mb-0 h5 ${doc.uploaded ? "text-success" : "text-danger"}`}>
                      {doc.document_descriptor_name || "Nombre no disponible"}
                    </h4>
                    {doc.uploaded ? (
                      <p className="small text-success mb-1">
                        Fecha de Actualización:{" "}
                        <span>{doc.updated_at ? new Date(doc.updated_at).toLocaleDateString("es-ES") : "Sin fecha"}</span>
                      </p>
                    ) : (
                      <p className="small text-danger mb-1">Documento no subido</p>
                    )}
                  </div>
                </div>
              </Col>
              <Col xs="12" sm="12" md="4" lg="4" className="mt-3 text-lg-right">
                {doc.uploaded && doc.download_url && (
                  <Button
                    color="info"
                    outline
                    size="sm"
                    href={doc.download_url}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Descargar
                  </Button>
                )}
              </Col>
            </Row>
          ))}
        </Fragment>
      );
    }
    return null;
  };

  const renderEnrollmentStatus = () => {
    if (stage.aasm_state === "approved") {
      return <Badge color="success">Aprobado</Badge>;
    } else if (stage.aasm_state === "rejected") {
      return <Badge color="danger">Rechazado</Badge>;
    } else {
      return <Badge color="secondary">Pendiente</Badge>;
    }
  };

  return (
    <Fragment>
      <a style={{ cursor: "pointer", color: "#006f5c" }} onClick={toggle}>
        {stage.name}
      </a>
      <Modal isOpen={modal} toggle={toggle} size="lg">
        <ModalHeader className="gradient-bg text-white" toggle={toggle}>
          Visualización de Etapa: {stage.name}
          <Col md="6" className="text-left">
            {renderEnrollmentStatus()}
          </Col>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md="12">
              <h5 className="font-weight-bold text-muted">Candidato</h5>
              <ApplicantData user={applicant.user} applicant={applicant} />
            </Col>
          </Row>
          {drawDocuments()}
          <Row>
            <Col md="12">
              <h5 className="font-weight-bold text-muted">Detalles de la Etapa</h5>
            </Col>
          </Row>


          {stage.metadata && Object.keys(stage.metadata).length > 0 && (
            <Row>
              <hr />
              <Col md="12">
                <h5 className="font-weight-bold text-muted">Datos Ingresados</h5>
                {Object.entries(stage.metadata).map(([key, value], index) => (
                  <FormGroup key={index}>
                    <Label>{key.replace("_", " ").toUpperCase()}</Label>
                    <p>{typeof value === "boolean" ? (value ? "Sí" : "No") : value || "No"}</p>
                  </FormGroup>
                ))}
              </Col>
            </Row>
          )}


          <hr/>
          <Row>
            <Col md="12">
              <FormGroup>
                <Label for="observations">Observaciones</Label>
                <p>{stage.observations || "No hay observaciones registradas."}</p>
              </FormGroup>
            </Col>
          </Row>

        </ModalBody>
        <ModalFooter className="gradient-bg">
          <Button color="secondary" onClick={toggle}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default StageView;
